<template>
  <div id="finalisation-screen">
    <div class="container">
      <div v-if="selectedInspection && commonData" class="row">
        <div class="row hidden-print text-right">
          <div class="col-12 print-row">
            <base-button
              :title="$t('app.inspection_memo.buttons.print')"
              :classNames="`btn btn-orange rounded finalize-button`"
              @clicked="print"
            />
          </div>
        </div>
        <inspection-header :inspection="selectedInspection.final_report"  :siteName="siteName"/>
        <report-list
          :statements="selectedInspection.final_report.inspections_statements"
        />
        <inspection-report-summary :data="selectedInspection.final_report"/>
        <div v-if="selectedInspection.final_report.inspection_notes.length > 0" class="panel panel-default border-panel card-view note-row">
          <div class="panel-wrapper collapse in">
            <div class="panel-heading">
              <div class="row">
                <div class="col-sm-12 header-row">
                  <div class="pull-left">
                    <h6 class="panel-title txt-dark">
                      <span>{{$t(`app.inspection_note.title`)}}</span>
                    </h6>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="panel-body">
              <div class="table-wrap mt-10">
                <div class="table-responsive participant-table">
                  <table class="table mb-0 note-table">
                    <tbody>
                      <tr
                        style="width: 100%"
                        class="table-row"
                        v-for="(note, index) in selectedInspection.final_report.inspection_notes"
                        :key="index"
                      >
                        <td style="width:95%">
                          <span>{{note.note}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="editable === false" class="panel panel-default border-panel card-view">
          <div class="panel-wrapper collapse in">
            <div class="panel-heading">
              <div class="row">
                <div class="col-sm-12 participants-title">
                  <div class="pull-left">
                    <h6 class="panel-title txt-dark">
                      <span>{{$t(`app.inspection_statement.participants.title`)}}</span>
                    </h6>
                  </div>
                  <div class="pull-right"></div>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="panel-body participant-body">
              <div class="table-wrap mt-10">
                <div class="table-responsive participant-table">
                  <table class="table mb-0">
                    <thead>
                      <tr style="width: 100%">
                        <th class="name">
                          <span>{{$t(`app.inspection_statement.participants.name`)}}</span>
                        </th>
                        <th class="phone">
                          <span>{{$t(`app.inspection_statement.participants.phone`)}}</span>
                        </th>
                        <th class="email">
                          <span>{{$t(`app.inspection_statement.participants.email`)}}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        style="width: 100%"
                        class="table-row"
                        v-for="(person, index) in selectedInspection.final_report.participants"
                        :key="index"
                      >
                        <td>
                          <span>{{person.name}}</span>
                        </td>
                        <td>
                          <span>{{person.phone}}</span>
                        </td>
                        <td>
                          <span>{{person.email}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-30">
          <approved-specializations
            :specializations="inspectionSpecializations"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import InspectionHeader from "./InspectionHeader.vue";
import InspectionReportSummary from "./InspectionReportSummary.vue";
import ParticipantList from "./ParticipantList.vue";
import BaseButton from "@/components/shared/buttons/BaseButton";
import InspectionReportList from "@/components/shared/lists/InspectionReportList";
import BaseDropdown from "@/components/shared/inputs/BaseDropDown";
import BaseTextarea from "@/components/shared/inputs/BaseTextArea";
import ApprovedSpecializations from './ApprovedSpecializations';

export default {
  name: "FinalizedInspectionScreen",
  components: {
    "inspection-header": InspectionHeader,
    "inspection-report-summary": InspectionReportSummary,
    "base-button": BaseButton,
    "participant-list": ParticipantList,
    "report-list": InspectionReportList,
    "base-dropdown": BaseDropdown,
    "base-textarea": BaseTextarea,
    ApprovedSpecializations
  },
  props: {},
  data() {
    return {
      siteName: "",
      newMemo: {
        text: undefined
      },
      newNote: {
        note: undefined
      },
      note: undefined,
      currentPageIndex: 1,
      searchTerm: "",
      partnerId: undefined,
      selectedInspection: null,
      selectedInspectionNotes: [],
      workers: undefined,
      editable: true,
      storedInspectionStatementId: undefined,
      inspectionSpecializations: undefined,
      results: [
        {
          value: "unknown",
          text: this.$t(`app.inspection_statement.results.unknown`)
        },
        {
          value: "matched",
          text: this.$t(`app.inspection_statement.results.matched`)
        },
        {
          value: "mismatched",
          text: this.$t(`app.inspection_statement.results.mismatched`)
        }
      ]
    };
  },
  created() {
    if (this.$route.name === "InspectionReportScreen") {
      this.editable = false;
    }
    this.fetchInspection({id: this.$route.params.id,withDeleted: true}).then(inspection => {
      this.fetchSite({
      partnerId: this.loggedInUser.partner_id,
      id: inspection.site_id,
    }).then((site) => {
      this.siteName = site.name
    });
      this.selectedInspection = inspection;
      this.inspectionSpecializations = inspection.inspection_specializations;
      this.partnerId = inspection.final_report.planner_user.partner_id;
    });
  },
  mounted() {},
  computed: {
    ...mapGetters({
      commonData: "partners/commonData",
      loggedInUser: "loggedInUser"
    }),
    participantsForList() {
      return this.workers.map(function(worker) {
        return {
          id: worker.id,
          text: worker.name
        };
      });
    },
    inspectionAttributes() {
      return [
        {
          name: "participants",
          type: "tag",
          list: this.participantsForList
        }
      ];
    },
    inspectionStatementAttributes() {
      return [
        {
          name: "result",
          type: "dropdown",
          dropdownList: this.results
        }
      ];
    },
    memoAttributes() {
      return [
        {
          name: "text",
          type: "text-area"
        }
      ];
    },
    noteAttributes() {
      return [
        {
          name: "note",
          type: "text-area"
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      fetchTask: "tasks/fetchTask",
      fetchInspection: "inspections/fetchInspection",
      fetchSite: 'sites/fetchSite',
    }),
    print() {
      document.title = this.selectedInspection.identifier + "_szemle"
      window.print();
      setTimeout(() => document.title = "SevesoRec | " + this.$t('app.inspections.title'), 1000);
    },
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
#finalisation-screen {
  .note-row {
    page-break-after: always;
  }

  .submit-row {
    margin: -12px;
    margin-top: 30px;
  }

  .print-row {
    margin: 7px;
    margin-top: 10px;
  }

  /deep/ .button-disabled {
    cursor: not-allowed !important;
  }
  .note-field {
    margin: 4px;
  }

  /deep/ .note-label {
    margin-bottom: 5px;
    color: #272B34;
    font-size: 14px;
  }
  .header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /deep/ .rounded {
    border-radius: 4px;
  }

    .vue-tags-input {
      max-width: 100%;
    }
    & /deep/ .ti-input {
      border: none !important;
      input[type="text"] {
        font-family: 'Roboto', sans-serif !important;
      }
    }
    & /deep/ .ti-tag {
      background-color: var(--main-color) !important;
      .ti-tag-center {
        font-family: 'Roboto', sans-serif !important;
      }
    }
    & /deep/ .ti-deletion-mark {
      background-color: #ee234f !important;
    }
    & /deep/ .ti-tag:before {
      display: none !important;
    }

  // .name, .phone, .email{
  // 	width: 33.3%;
  // }
}
@media print {
  #finalisation-screen {
    overflow: hidden;
    font-size: 10px;
  }

  .participants-title {
    span {
      font-size: 13px;
    }
    padding-left: 0px;
  }

  .participant-body {
    padding-top: 0 !important;
  }

  .page-wrapper {
    padding: 0px 20px;
  }

  .button-disabled {
    display: none;
  }

  .action-field, .note-field {
    display: none;
  }

  .finalize-button {
    display: none;
  }

  .participant-table {
    td,
    th {
      font-size: 12px !important;
      border: 1px solid #eee !important;
    }

    .phone {
        width: 20% !important;
      }

      .autograph {
        width: 30% !important;
      }

      .name {
        width: 30% !important	;
      }

      .email,
      .date {
        width: 30% !important	;
      }
  }

  .action-button {
    cursor: pointer;
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inspections/FinalizedInspectionScreen.vue